import RewardWrapper from "@/components/RewardWrapper"
import { FailedProps } from "@hg/activity-utils"
import React from "react"
import styles from "./index.module.scss"
import { i18n } from "@/i18n"

const Failed = ({ onClose, type }: FailedProps) => {
    return (
        <RewardWrapper onClose={onClose}>
            <div className={styles.failed}>
                <div className={styles.img} />
                <div className={styles.text}>
                    {type === "default" && i18n.get("reward.text_fail")}
                    {type === "noReward" && i18n.get("reward.text_noReward")}
                </div>
            </div>
        </RewardWrapper>
    )
}

export default Failed
